$(function () {
  if ($('.container-regionmap').length) {
    setTimeout(function () {
      var items = $(".regionmap__section, .regionmap__element");

      $.each(items, function (index, item) {
        //$(item).on("touchstart", setMap);
        $(item).on("mouseenter", setMap);
        $(item).on("focus", setMap);

        //$(item).on("touchend", unsetMap);
        $(item).on("mouseleave", unsetMap);
        $(item).on("blur", unsetMap);
      });

      $.each(items, function (index, item) {
        $(item).on("click", function () {
          var id = $(item).attr("data-id");
          var link = $(
            '.regionmap__element[data-id="' + id + '"] a'
          ).attr("href");
          window.location.href = link;
        });
      });
    }, 400);
  }
});

function setMap(ev) {
  var id = this.getAttribute("data-id");
  $(".regionmap__element.link-active").removeClass("link-active");
  $('.regionmap__element[data-id="' + id + '"]').addClass("link-active");
  $(".regionmap__section.map-active").removeClass("map-active");
  $('.regionmap__section[data-id="' + id + '"]').addClass("map-active");
  $("#regionmap-caption-" + id).addClass("current");
  return false;
}

function unsetMap(ev) {
  $(".regionmap__element.link-active").removeClass("link-active");
  $(".regionmap__section.map-active").removeClass("map-active");
  $(".regionmap__caption.current").removeClass("current");
  return false;
}
